module.exports = __webpack_public_path__ + "img/case14.ab2ccce0.jpg";